import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { HeadRow } from 'components/HeadRow';
import { useDayPicker } from 'contexts/DayPicker';
/** Render the table head. */
export function Head() {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var HeadRowComponent = (_a = components === null || components === void 0 ? void 0 : components.HeadRow) !== null && _a !== void 0 ? _a : HeadRow;
    return (_jsx("thead", __assign({ style: styles.head, className: classNames.head }, { children: _jsx(HeadRowComponent, {}) })));
}
//# sourceMappingURL=Head.js.map